import React, { useState } from "react"
import { Radio } from "antd"

interface ShiftTypeCardProps {
  title: string
  description: string
  expandedDescription: string
  example: string
  image: string
  isSelected: boolean
  onSelect: () => void
}

const ShiftTypeCard: React.FC<ShiftTypeCardProps> = ({
  title,
  description,
  expandedDescription,
  example,
  image,
  isSelected,
  onSelect,
}) => {
  const [expanded, setExpanded] = useState(false)

  const toggleMoreInfo = (e: React.MouseEvent) => {
    e.stopPropagation()
    setExpanded(!expanded)
  }

  return (
    <div
      className={`relative flex ${
        expanded ? "items-start" : "items-center"
      } gap-4 p-4 rounded-lg border-2 cursor-pointer transition-all ${
        isSelected
          ? "border-[#004AF5] bg-[#E2EAFE]"
          : "border-[#E2E8F0] hover:border-[#CBD5E1] bg-slate-100"
      }`}
      onClick={onSelect}
    >
      <div className="shrink-0">
        <img
          src={image}
          alt=""
          className="opacity-60"
        />
      </div>
      <div className="flex-1 flex flex-col gap-1 pr-8">
        <h4 className="font-bold text-base text-[#0F172B]">{title}</h4>
        <p className="text-sm text-slate-500">
          {expanded ? expandedDescription : description}
        </p>
        {expanded && (
          <p className="text-sm text-slate-500 mt-2">
            <span className="font-bold text-[#0F172B]">Example:</span> {example}
          </p>
        )}
        <button
          type="button"
          className="self-start text-[#004AF5] text-sm font-semibold flex items-center gap-0.5 mt-1"
          onClick={toggleMoreInfo}
        >
          {expanded ? "Less info —" : "More info +"}
        </button>
      </div>
      <Radio
        checked={isSelected}
        className="shrink-0 absolute top-4 right-4"
      />
    </div>
  )
}

export default ShiftTypeCard
